import { createFileRoute } from '@tanstack/react-router';

import { TestPlanDetailOutletWithForm } from './-context/test-plan-tab-form-context';
import { TestPlanFormStore } from './-store/store';

export const Route = createFileRoute(
  '/_stacktrace/test-suites/$id/_layout/test-plan/_layout',
)({
  component: TestPlanLayout,
});

/**
 * テストプランタブの Layout。
 *
 * Value 詳細の `_layout.tsx` と同パターンで、Zustand store Provider を張り、
 * その配下に {@link TestPlanDetailOutletWithForm} を置いて全セクションで同一
 * フォームストアを共有する。サイドバー（ナビゲーション）はページ本体の CForm が
 * `navigationSectionGroups` で描画するため、ここでは別途置かない。
 */
function TestPlanLayout() {
  const store = TestPlanFormStore.createStore();
  return (
    <TestPlanFormStore.Provider value={store}>
      <TestPlanDetailOutletWithForm />
    </TestPlanFormStore.Provider>
  );
}
